// A szervertől (General.getRendConf) betöltött, nyilvános beállítások.
export default class RendConf{
    static page_title = undefined;
    static contact_email = undefined;
    static szabalyzatURL = undefined;
    // A belépő oldal címe és alcíme (az adatbázis beallitasok táblájából)
    static oldal_cim = undefined;
    static oldal_alcim = undefined;
    // a rövidített alcím (a rendezvénylista fejlécében)
    static oldal_alcim_rovid = undefined;
    // A Google-belépés Client ID-je (nem titok); ha üres, a Google gomb nem jelenik meg.
    static google_login_client_id = undefined;
    // Az API belépési pontjának címe (public/RendConfJs.json), pl. "/api/index.php"
    static url_api = undefined;
}
